import PropTypes from 'prop-types';
import { useState, createContext, useContext } from 'react';
const activityContext = createContext();

export const ActivityProvider = ({ children }) => {
  const [assignedData, setAssignedData] = useState([]);
  const [noOfActivities, setNoOfActivities] = useState(0);
  const [isActivitiesAvailable, setIsActivitiesAvailable] = useState(true);
  const [filters, setFilters] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const [selectedFolderId, setSelectedFolderId] = useState('');
  const [selectedStatusId, setSelectedStatusId] = useState([]);
  const [selectedKeyWord, setSelectedKeyWord] = useState('');
  const [folderUpdateStatus, setFolderUpdateStatus] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(0);
  const [search, setSearch] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [assignedDataStatus, setAssignedDataStatus] = useState(new Date().getSeconds());
  const [activityId, setActivityId] = useState('');
  const [availabilityOption, setAvailabilityOption] = useState('Always');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [activityMode, setActivityMode] = useState('open');
  const [textToSpeech, setTextToSpeech] = useState(false);
  const [initialFromValue, setInitialFromValue] = useState('');
  const [initialToValue, setInitialToValue] = useState('');
  const [assignedCount, setAssignedCount] = useState(0);
  const [studentFileUpload, setStudentFileUpload] = useState(false);
  const [randomized, setRandomized] = useState(false);
  const [isFiltersCollapsed, setIsFiltersCollapsed] = useState(false);  
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [activityName, setActivityName] = useState('');
  const [activityCourseId, setActivityCourseId] = useState('');

  return (
    <activityContext.Provider
      value={{
        assignedData,
        setAssignedData,
        noOfActivities,
        setNoOfActivities,
        isActivitiesAvailable,
        setIsActivitiesAvailable,
        filters,
        setFilters,
        selectedCourseId,
        setSelectedCourseId,
        selectedFolderId,
        setSelectedFolderId,
        selectedStatusId,
        setSelectedStatusId,
        selectedKeyWord,
        setSelectedKeyWord,
        folderUpdateStatus,
        setFolderUpdateStatus,
        selectedActivity,
        setSelectedActivity,
        search,
        setSearch,
        isAllSelected,
        setIsAllSelected,
        selectedCount,
        setSelectedCount,
        assignedDataStatus,
        setAssignedDataStatus,
        activityId,
        setActivityId,
        availabilityOption,
        setAvailabilityOption,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        activityMode,
        setActivityMode,
        textToSpeech,
        setTextToSpeech,
        initialFromValue,
        setInitialFromValue,
        initialToValue,
        setInitialToValue,
        assignedCount,
        setAssignedCount,
        studentFileUpload,
        setStudentFileUpload,
        randomized,
        setRandomized,
        isFiltersCollapsed,
        setIsFiltersCollapsed,
        filtersInitialized,
        setFiltersInitialized,
        sortDirection,
        setSortDirection,
        sortColumn,
        setSortColumn,
        activityName,
        setActivityName,
        activityCourseId,
        setActivityCourseId
      }}>
      {children}
    </activityContext.Provider>
  );
};

ActivityProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useActivityContext = () => useContext(activityContext);
